import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

//Hooks

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Components
import { Spinner } from '@arredo/reactjs-ui'
// Others
import MovementService from '../../../services/movementService';

const ShowMovementsModal = ({ product, onClose, open }) => {
    const [movements, setMovements] = useState({income:0, outcome: 0});
    const [loading, setLoading] = useState();

    useEffect(() => {
        if(open === true ) {
            MovementService
                    .GetIncomeOutcome(product.id)
                    .then(model => {
                        setMovements(model);
                    })
                    .finally(() => setLoading(false));
        }
    }, [open, product])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {`Movimientos en el producto '${product?.refId}'`}
            </DialogTitle>
            <DialogContent style={{ minWidth: 430 }}>
                {
                    loading &&
                    <Spinner lockScreen />
                }
                <Grid container direction='column'>
                    <Grid>
                        <h4>Ingresos: {movements.income}</h4>
                        <h4>Egresos: {movements.outcome}</h4>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                >
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

ShowMovementsModal.defaultProps = {
    onClose: () => {},
}

ShowMovementsModal.prototype = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    product: PropTypes.object
}

export default ShowMovementsModal;